module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-f3b11f11f174d04d749f45fa058e6f75.png";